import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import { withPrefix } from 'gatsby-link';

import {
  getBackgroundColorFromContentfulType,
  getHumanReadableContentTypeFromContentfulType,
  getSlugFromContentfulType,
} from 'helpers/contentfulTypes';

import Card from 'components/Card';
import Heading from 'components/Heading';
import Tag from 'components/Tag';

import { A, Child, Flex } from 'components/PageLinkStyles';

const PageLink = ({ className, page }) => {
  const { slug, title, shortDescription, content } = page;
  const { contentfulType } = content[0];
  return (
    <A
      className={className}
      href={withPrefix(`${getSlugFromContentfulType(contentfulType)}/${slug}`)}
    >
      <Card padding={24}>
        <Flex>
          <Child>
            <Tag
              bg={getBackgroundColorFromContentfulType(
                content[0].contentfulType
              )}
              textColor={waffles => waffles.theme.colors.white}
            >
              {getHumanReadableContentTypeFromContentfulType(contentfulType)}
            </Tag>
            <Heading element="h3">{title}</Heading>
            {shortDescription}
          </Child>
        </Flex>
      </Card>
    </A>
  );
};

PageLink.defaultProps = {
  className: null,
};

PageLink.propTypes = {
  className: string,
  page: shape({
    title: string.isRequired,
    slug: string.isRequired,
    shortDescription: string.isRequired,
    content: arrayOf(
      shape({
        contentfulType: string.isRequired,
      })
    ),
  }).isRequired,
};

export default PageLink;
